import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { type AdminUserDetail } from "@currencycore/shared";
import { getUser } from "../lib/api.ts";
import { UserDetailBody } from "../components/UserDetailBody.tsx";
import { toast } from "../components/Toast.tsx";
import { errMsg } from "../lib/ui.ts";

export function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [detail, setDetail] = useState<AdminUserDetail | null>(null);

  useEffect(() => {
    if (!id) return;
    getUser(id).then(setDetail).catch((e) => toast(errMsg(e, "Failed to load user.")));
  }, [id]);

  if (!detail) {
    return (
      <div className="page-loading">
        <span className="spinner spinner-lg" />
      </div>
    );
  }

  return (
    <>
      <div className="page-head">
        <div>
          <Link to="/users" className="back-link">← Users</Link>
          <h1>{detail.name ?? "User"}</h1>
          <p className="muted mono">{detail.email}</p>
        </div>
        <div className="page-head-actions">
          {detail.banned ? (
            <span className="badge badge-danger">banned</span>
          ) : (
            <span className="badge badge-ok">active</span>
          )}
        </div>
      </div>

      <div className="card card-pad detail-single">
        <UserDetailBody detail={detail} onUpdated={setDetail} onDeleted={() => navigate("/users")} />
      </div>
    </>
  );
}
